import { BodyText } from "@/components/ui";
import type { ChatMessage } from "@/features/Chat/types/chatMessageTypes";
import { Practitioner } from "@curai/js-fhir-tools";
import { formatDate } from "date-fns";

interface NoteClosedMessageProps {
  message: ChatMessage;
}

export const NoteClosedMessage = ({ message }: NoteClosedMessageProps) => {
  const practitioner = new Practitioner(message.practitioner as object);

  return (
    <div className="flex flex-col gap-1 justify-center items-center">
      <BodyText size="sm" textColor="primary" italic>
        {practitioner.chatTitle} has closed a note.
      </BodyText>
      <BodyText size="xs" textColor={"tertiary"}>
        {formatDate(new Date(message.created), "MM/dd/yyyy h:mm a")}
      </BodyText>
    </div>
  );
};
